
<p-panelMenu [model]="items" [multiple]="false" [style]="{'width':'auto','background-color':'transparent'}" tooltipEvent="focus"  >

</p-panelMenu>